import { TmcContextService } from './../../../../common/tmc-context.service';

import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractWidgetComponent, ContextChange, DialogService, ResponseMessage, TranslationService, WidgetStyle } from '@sdbn/common';
import { ConfirmDialogComponent } from '@sdbn/tmc-legacy';
import { StructureSelectionService } from '../../../../common/structure-selection/structure-selection-dialog/structure-selection-dialog-service';
import { YardAdministrationService } from '../yard-administration.service';
@Component({
    selector: 'app-yard-administration',
    templateUrl: './yard-administration.component.html',
    styleUrls: ['./yard-administration.component.scss'],
    standalone: false
})
export class YardAdministrationComponent extends AbstractWidgetComponent implements OnInit {

  responseMessages: ResponseMessage[];

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private yardAdministrationService: YardAdministrationService,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) {
    super();
  }

  ngOnInit() {
  }

  public triggerYardClientsReload(): void {
    this.responseMessages = [];

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        titleKey: 'tmc-yard.ui.admin.yard-administration.reload-yard-clients.confirm-dialog.title',
        messageKey: 'tmc-yard.ui.admin.yard-administration.reload-yard-clients.confirm-dialog.message',
        confirm: () => {
          this.yardAdministrationService.triggerYardClientsReload().subscribe(
            response => {
              this.responseMessages = response.responseMessages;
            }
          );
        }
      }
    });
  }

  public createEmergencyPrintout() {
    this.yardAdministrationService.emergencyCall(this.translationService.language);
  }

  public exportConfiguration() {
    this.yardAdministrationService.exportConfiguration(this.tmcContextService.getYardKey())
  }

  public cleanTransports() {
    this.responseMessages = [];

    this.dialogService.showConfirm('tmc-yard.ui.admin.yard-administration.clean-transports.confirm-dialog.title', 'tmc-yard.ui.admin.yard-administration.clean-transports.confirm-dialog.message').afterClosed().subscribe(
      confirmed => {
        if (confirmed) {
          this.yardAdministrationService.cleanTransports().subscribe(
            response => {
              this.responseMessages = response.responseMessages;
            }
          );
        }
      });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  getStyle() {
    return WidgetStyle.transparent;
  }

}
